import React from 'react';
import { motion } from 'framer-motion';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Green Valley School',
      location: 'Patna, Bihar',
      type: 'School',
      beforeBill: 45000,
      afterBill: 8000,
      reduction: 82,
      systemSize: '10KW',
      testimonial: 'We installed a 10KW solar system and our electricity bill dropped from ₹45,000 to just ₹8,000 per month. The savings have been incredible!'
    },
    {
      id: 2,
      name: 'St. Mary\'s College',
      location: 'Kolkata, West Bengal',
      type: 'College',
      beforeBill: 65000,
      afterBill: 12000,
      reduction: 82,
      systemSize: '15KW',
      testimonial: 'Solar has been a game-changer for our college. We\'re saving over ₹50,000 every month, which we can now invest in better facilities for our students.'
    },
    {
      id: 3,
      name: 'Sunshine Public School',
      location: 'Delhi',
      type: 'School',
      beforeBill: 32000,
      afterBill: 5500,
      reduction: 83,
      systemSize: '8KW',
      testimonial: 'The 1 rupee downpayment made it so easy for us to switch to solar. Our EMI is less than what we were paying for electricity before!'
    },
    {
      id: 4,
      name: 'Modern Academy',
      location: 'Mumbai, Maharashtra',
      type: 'School',
      beforeBill: 55000,
      afterBill: 9500,
      reduction: 83,
      systemSize: '12KW',
      testimonial: 'Best decision we made! Not only are we saving money, but we\'re also teaching our students about renewable energy and sustainability.'
    }
  ];

  return (
    <section className="testimonials-section">
      <div className="container">
        <motion.div
          className="testimonials-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Success Stories</h2>
          <p className="section-subtitle">See how schools and colleges are reducing their electricity bills with solar</p>
        </motion.div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              className="testimonial-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div className="testimonial-header">
                <div className="testimonial-info">
                  <h3 className="testimonial-name">{testimonial.name}</h3>
                  <p className="testimonial-location">{testimonial.location}</p>
                  <span className="testimonial-type">{testimonial.type}</span>
                </div>
              </div>

              <div className="testimonial-stats">
                <div className="stat-item before">
                  <span className="stat-label">Before</span>
                  <span className="stat-value">₹{testimonial.beforeBill.toLocaleString('en-IN')}</span>
                </div>
                <div className="stat-arrow">→</div>
                <div className="stat-item after">
                  <span className="stat-label">After</span>
                  <span className="stat-value">₹{testimonial.afterBill.toLocaleString('en-IN')}</span>
                </div>
              </div>

              <div className="reduction-badge">
                <span className="reduction-icon">📉</span>
                <span className="reduction-text">{testimonial.reduction}% Reduction</span>
              </div>

              <div className="system-info">
                <span className="system-label">System Size:</span>
                <span className="system-value">{testimonial.systemSize}</span>
              </div>

              <p className="testimonial-text">"{testimonial.testimonial}"</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

